var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0207(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o75xefkmaa",
    d: "M5 4h38v16H5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "vmk7d5lxib",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 38,
    height: 16,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o75xefkmaa"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#vmk7d5lxib)",
    xlinkHref: "#o75xefkmaa",
    stroke: "#F5A8BE",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "5,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0207);
export default __webpack_public_path__ + "static/media/icon-legend-02-07.bf5c14e18285c3bc51660a0d68a03595.svg";
export { ForwardRef as ReactComponent };